import {popupEditWork} from '../common/PopupForms';
import Api from "../common/Api";

export function tableProjectWorks(HelperTable) {
    const selectorTable = '#table_project_works';
    const elTable = $(selectorTable)

    if (!elTable.length) return;

    const isPostAuthor =     ESR.Helper.isPostAuthor()
    const canCreateWork = ESR.Helper.userCan('create_work');
    const canEditWork = ESR.Helper.userCan('edit_work');
    const canDeleteWork = ESR.Helper.userCan('delete_work');
    const canEditWorkOther = ESR.Helper.userCan('edit_others_work');
    const isPublish = ESR.post.status === 'publish'
    const canViewReports = ESR.Helper.userCan('view_reports')

    const colIndexCapitol = 3;
    const colIndexWorker = 6;
    const isMobile = window.innerWidth < 768
    const isDesktop = window.innerWidth >= 1160


    const render_column_workers = (data, type, row) => {

        let html = '';
        let counter = 0;

        if (type === 'display') {
            row?.workers.forEach(worker => {
                const name = worker?.name.length ? worker.name : 'user id ' + worker.id;
                const title = canViewReports ? `<span title="${worker.coef}">${name}</span>` : name;
                html += counter === 0 ? '' : ' <span>,</span> ';
                html += title;
                counter++;
            });
            return html;
        } else if (type === 'filter') {
            row?.workers.forEach(worker => {
                const name = worker?.name.length ? worker.name : '';
                html += worker.id + ' ' + name;
                html += counter === 0 ? '' : ' |';
                counter++;
            });
            return html;
        }

        return data;
    }

    let columns = [
        {
            className: 'dt-control',
            orderable: false,
            data: null,
            defaultContent: '',
            render: (data) => data?.comment_id ? '<span class="has-content"></span>' : '',
        },
        {
            label: ESR.lang.id,
            data: 'id',
            className: 'id min-mobile',
            visible: true
        },
        {
            label: ESR.lang.date,
            data: 'date',
            name: 'date',
            className: 'date min-tablet-p',
            visible: true,
            orderable: true
        },
        {
             label: ESR.lang.service_title,
            data: 'service_title',
            className: 'service_title min-mobile',
            visible: true,
            orderable: true
        },

        {
            label: ESR.lang.chapter,
            data: 'term_name',
            className: 'term_name',
            visible: false,
            render: HelperTable.renderColumnTermName
        },
        {
            label: ESR.lang.qty,
            data: 'qty',
            className: 'qty min-tablet',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.unit,
            data: 'unit',
            className: 'unit min-tablet',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.workers,
            data: 'workers',
            className: 'workers',
            orderable: false,
            render: render_column_workers,
            visible: true
        },
        {
            label: ESR.lang.created,
            data: 'created',
            className: 'created',
            visible: !isDesktop
        },
        {
            label: ESR.lang.updated,
            data: 'updated',
            className: 'updated',
            visible: !isDesktop
        },
        {
            label: ESR.lang.author,
            data: 'modified_name',
            className: 'moderator',
            visible: !isDesktop
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    let toolbarButtons = [
        HelperTable.btnColvis(),
        HelperTable.btnDownloads()
    ];

    if (isPublish) {
        if ( canCreateWork ) {
            toolbarButtons.push(HelperTable.btnAdd((e, dt, el, config) => {
                const currentUrl = window.location.href;
                const newUrl = currentUrl.endsWith('/') ? currentUrl + 'add/' : currentUrl + '/add/';
                window.location.href = newUrl;
            }));
        }
        if ( canEditWork ) toolbarButtons.push(HelperTable.btnEdit())
        if ( canDeleteWork ) toolbarButtons.push(HelperTable.btnRemove())
    }


    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        // ajax: {
        //     url: ESR.ajaxurl,
        //     type: 'POST',
        //     data: {
        //         action: 'esr_table_project_works',
        //         post_id: ESR.post.id
        //     }
        // },
        columns: columns,
        order: [
            [1, 'dsc']
        ],
        stateSave: true,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: {
                buttons: toolbarButtons
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
            buttons: {
                // colvis: 'Coloane',
                // pageLength: ''
            }
        },
        displayLength: 50,
        drawCallback: function (settings) {
            var api = this.api();

            if (api.column(colIndexCapitol).visible()) {
                return;
            }

            var rows = api.rows({page: 'current'}).nodes();
            var last = null;


            api.column(colIndexCapitol, {page: 'current'}).data()
                .each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before('<tr class="group"><td colspan="11">' + group + '</td></tr>');
                        last = group;
                    }
                });
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()

            const colChapter = api.column(colIndexCapitol)
            const colChapterStateValue = state?.columns[colIndexCapitol].search.search ?? '';
            const optionsChapter = HelperTable.serializeChapterOptions(window.tableData);
            const elSelectChapter = ESR.View.select({
                value: colChapterStateValue,
                placeholder: ESR.lang.all_chapter,
                class: 'select select-bordered select-sm',
                options: optionsChapter
            }).on('change', function () {
                colChapter.search($(this).val(), {exact: false}).draw();
            });

            const colWorker = api.column(colIndexWorker)
            const colWorkerStateValue = state?.columns[colIndexWorker].search.search ?? ''
            const optionsWorkers = HelperTable.serializeWorkersOptions(window.tableData);
            const elSelectWorker = ESR.View.select({
                value: colWorkerStateValue,
                placeholder: ESR.lang.all_workers,
                class: 'select select-bordered select-sm',
                options: optionsWorkers
            }).on('change', function () {
                colWorker.search($(this).val(), {exact: false}).draw();
            });

            $('.dt-layout-row:eq(0) >.dt-layout-end').prepend(elSelectChapter).prepend(elSelectWorker)
        }
    });

    const btnRowEdit = table.buttons().container().find('.btn-row-edit')
    const btnRowRemove = table.buttons().container().find('.btn-row-remove')

    //Re-draw table when display direction of column "Capitol" is toggled
    table.on('buttons-action', function (e, buttonApi, dataTable, node, config) {
        if (buttonApi.text() === ESR.lang.chapter) table.draw();
    });

    $('body').on('click', (e) => {
        HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
    });

    const callbackWarningPopup = (rowData) => {
        const currentUserID = ESR.Helper.getUserID()
        const isCurrentProjectManager = ESR.Helper.getPostAuthorID() === currentUserID
        const isWorkAuthor = parseInt(rowData.modified_by) === currentUserID
        const canEditOthersProject = ESR.Helper.userCan('edit_others_project')
        const canContinue = canEditOthersProject || isCurrentProjectManager || isWorkAuthor

        if (!canContinue) {
            ESR.Popup.warning({
                html: `<p>Autorul este <b>${rowData.modified_name}</b>, Dvs. nu aveți permisiuni.</p> <p>Contactați autorul sau mănagerul pentru corectări.</p>`,
                confirmButtonText: ESR.lang.close,
            });
            return false;
        }

        return true;
    }

    const callbackRowEdit = (e) => {
        e.preventDefault();

        const elRow = table.row('.selected');
        if (!elRow.node()) return;   // "No row selected."
        const rowData = elRow.data();
        if (!rowData?.id) return;

        const canContinue = callbackWarningPopup(rowData)

        if (canContinue) popupEditWork(rowData);
    }

    const callbackRowDelete = (e) => {
        e.preventDefault();
        const elRow = table.row('.selected');
        if (!elRow.node()) return;   // "No row selected."
        const rowData = elRow.data();

        const canContinue = callbackWarningPopup(rowData)

        if (!canContinue) return;

        const popupHTML = `
            <p class="mb-4">Doriți să ștergeți îngresitrarea ?</p>
            <table class="table table-zebra table-sm">
            <tr><th style="width: 90px">ID</th><td>${rowData.id}</td></tr>
            <tr><th style="width: 90px">Data</th><td>${rowData.date}</td></tr>
            <tr><th style="width: 90px">Titlu</th><td>${rowData.service_title}</td></tr>
            <tr><th style="width: 90px">Volum</th><td>${rowData.qty} ${rowData.unit} </td></tr>
            </table>`;

        ESR.Popup.delete({
            html: popupHTML,
            action: 'esr_delete_work',
            id: rowData.id
        })
    }



    // Formatting function for row details - modify as you need
    async function renderRowChild(row) {
        const data = row.data();
        const work_id = data.id;
        const elCommendID = `comments-${work_id}`;
        let HTML = `<div id="${elCommendID}">Loading...</div>`;

        row.child(HTML).show();

        try {
            const loadComment =  await  Api.loadComment(work_id);

            if(loadComment.success === false){
                throw new Error(`Error: ${loadComment.message}`);
            }

            const commentObj = loadComment.data

            document.getElementById(elCommendID).innerText = commentObj?.comment ?? '';
        } catch (error) {
            console.error('Error loading comments:', error);
            document.getElementById(elCommendID).innerText = error.message;
        }
    }

    // Add event listener for opening and closing details
    elTable.on('click', 'tbody td.dt-control', async function (e) {
        let tr = e.target.closest('tr');
        let row = table.row(tr);

        if (row.child.isShown()) {
            row.child.hide();
        }else {
            renderRowChild(row)
        }
    });

    if (btnRowEdit.length) btnRowEdit.click(callbackRowEdit);
    if (btnRowRemove.length) btnRowRemove.click(callbackRowDelete);

    document.body.addEventListener('change', function (event) {
        const target = event.target; // Get the changed element
        // Check if the target is an input or select element
        if (target.closest('#swal2-html-container') && (target.tagName === 'INPUT' || target.tagName === 'SELECT')) {
            target.classList.add('updated'); // Add the updated class
        }
    });
}